var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131 40",
    width: 131,
    height: 40,
    role: "img",
    "aria-label": "OGQBank",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#af186b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 12,
    dy: "0.35em",
    textAnchor: "middle",
    fontFamily: "Roboto, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 15.36,
    fontWeight: 800,
    fill: "#ffffff"
  }, "O"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 28,
    fontFamily: "Roboto, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#8c1d5a",
    letterSpacing: -0.66
  }, "OGQ", /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 800,
    fill: "#591239"
  }, "Bank"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f88466cec4f2c11b8cd76e9b64f25471.svg";
export { ForwardRef as ReactComponent };